// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'unwrap';

export const Component = () => (
  <g fill='none' stroke='currentColor'>
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M3 10h5m-5 2.5V8.087c0-.686.263-1.344.732-1.83A2.458 2.458 0 0 1 5.5 5.5a2.46 2.46 0 0 1 1.768.758A2.63 2.63 0 0 1 8 8.087V12.5'
    />
    <path d='M15.063 9.768H10m5.38 0-1.768 1.768M15.75 10.1 13.639 8' />
  </g>
);

export const viewBox = '0 0 18 18';
